import { DataColumns } from '../DataColumns/DataColumns';
import GridFlag from '../../../../Core/Components/GridFlag/GridFlag';
import {
  TenantFilterCell,
  BooleanValuesFilterCell,
  GridDateCell,
  GridDateTimeCell,
} from '../../../../Core/Components/Filter/FilterElements';
import { MultiViewCalenderFilterCell } from 'smart-react';
/**
 * Generates a list of columns for a grid.
 * @param {object} options - The options for the grid.
 * @returns {Array} - The list of grid columns.
 */
export const GridColumnsList = async ({
  dateRangefilter,
  setDateRangeFilter,
}) => {
  return DataColumns({
    GridFlag,
    TenantFilterCell,
    BooleanValuesFilterCell,
    MultiViewCalenderFilterCell,
    dateRangeFilter: dateRangefilter,
    setDateRangeFilter,
    GridDateCell,
    GridDateTimeCell,
  });
};

export default GridColumnsList;
